// /home asks for one thing at a time: the map first, the L3 consent sheet after the first map interaction, and
// the notification prompt only once that sheet has been answered or left.
export const MAP_INTERACTION_EVENT = "region-map:interaction"
export const CONSENT_DONE_EVENT = "consent-prompt:done"

function waitFor(eventName, ready, callback, win) {
  if (ready) {
    callback()
    return () => {}
  }
  const handler = () => callback()
  win.addEventListener(eventName, handler, { once: true })
  return () => win.removeEventListener(eventName, handler)
}

// An unanswered consent sheet on this page
export function consentPending(doc = document) {
  const sheet = doc.querySelector('[data-controller~="consent-prompt"]')
  return Boolean(sheet) && sheet.dataset.answered !== "true"
}

// Runs callback once the consent sheet is out of the way (now, when there is none). Returns a cancel function.
export function afterConsentPrompt(callback, { doc = document, win = window } = {}) {
  return waitFor(CONSENT_DONE_EVENT, !consentPending(doc), callback, win)
}

// Runs callback on the first pan or zoom of this map visit. Returns a cancel function.
export function afterMapInteraction(callback, { win = window } = {}) {
  return waitFor(MAP_INTERACTION_EVENT, false, callback, win)
}
